import { SharedUtils } from "../utilities/shared-utils";
import { EnumEntity } from "./encode-status-info";

export class EncodeErrorInfo {
    id: number | undefined;
    code: string | undefined;
    message: string | undefined;
    entity: EnumEntity | undefined;

    static fromJSON(json: any): EncodeErrorInfo {
        if (SharedUtils.inputValueIsPresent(json)) {
            if (typeof json === 'string') {
                try {
                    json = JSON.parse(json);
                } catch (error: any) {
                    console.error("Failed to parse JSON string: ", json);
                }
            }
            const error = new EncodeErrorInfo();
            error.id = json.id ?? '';
            error.code = json.code ?? '';
            error.message = json.message ?? '';
            // error.entity = Object.entries(EnumEntity).find(([key, value]) => key === json.entity)?.[0] as EnumEntity;
            if (json.entity && json.entity in EnumEntity) {
                error.entity = json.entity as keyof typeof EnumEntity as EnumEntity ?? '';
            }
            return error;
        }
        return new EncodeErrorInfo();
    }

    toString(): string {
        return "ERROR INFO. id: " + (this.id ?? 'none') + ", Code: " + (this.code ?? 'none') + ", Message: " + (this.message ?? 'none') + ", Entity: " + (this.entity ?? 'none');
    }
}

export enum EnumEncodeError {
    NICKNAME_BUSY="nickname_busy",
    EMAIL_BUSY="email_busy",
    FISCAL_CODE_BUSY="fiscal_code_busy",
    NOT_AUTHENTICATED="not_authenticated",
    USER_NOT_FOUND="user_not_found",
    USER_NOT_VERIFIED="user_not_verified",
    PERMISSION_DENIED="permission_denied",
    APPLICATION_COMPONENT_NOT_FOUND="application_component_not_found",
    APPLICATION_FUNCTIONALITY_NOT_FOUND="application_functionality_not_found",
    CITIZEN_NOT_FOUND="citizen_not_found",
    LEGAL_ENTITY_NOT_FOUND="legal_entity_not_found",
    ROLE_NOT_FOUND="role_not_found",
    EMAIL_TOKEN_EXPIRED="email_token_expired",
    EMAIL_TOKEN_NOT_FOUND="email_token_not_found",
    WRONG_PASSWORD="wrong_password",
    EMAIL_NOT_FOUND="email_not_found",
    NICKNAME_NOT_FOUND="nickname_not_found",
    JWT_STRATEGY_ERROR="jwt_strategy_error",
    ENTITY_NOT_FOUND="entity_not_found",
    CLIENT_UUID_NOT_FOUND="client_uuid_not_found",
    CLIENT_FINGERPRINT_NOT_FOUND="client_fingerprint_not_found",
    CLIENT_FINGERPRINT_DECRYPTION_ERROR="client_fingerprint_decryption_error",
    WRONG_CLIENT_UUID="wrong_client_uuid",
    VAT_NUMBER_BUSY="vat_number_busy",
    SESSION_UUID_TOKEN_NOT_FOUND="session_uuid_token_not_found",
    ADDRESS_NOT_FOUND="address_not_found",
    LEGAL_ENTITY_TOKEN_NOT_FOUND="legal_entity_token_not_found",
    MALFORMED_LEGAL_ENTITY_TOKEN="malformed_legal_entity_token",
    NOT_ENOUGH_USER_SYSTEM_ADMINISTRATORS='not_enough_user_system_administrators',
    NOT_ENOUGH_USER_LEGAL_ENTITY_ADMINISTRATORS='not_enough_user_legal_entity_administrators'
}